import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loader from '../common/Loader';
import { useAuth } from '../../hooks/useAuth';

function ProtectedRoute() {
  const { user, isLoading, connectionProblem, retryConnection } = useAuth();

  if (isLoading) {
    return <Loader label="Loading KrishvaQ..." />;
  }

  if (!user && connectionProblem) {
    // The session could not be checked because KrishvaQ could not be
    // reached - not because it was rejected. Do not sign anyone out of the
    // page they asked for; let them retry.
    return (
      <div role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
        <p>We couldn&apos;t reach KrishvaQ. Check your connection and try again.</p>
        <button type="button" onClick={retryConnection}>
          Try again
        </button>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
